<template>
  <v-container fluid class="payment-gateways-container">
    <v-tabs slider-color="#587e27" class="futuristic-tabs">
      <v-tab key="bank_slip" @click="fetchBankSlip()" class="earth-color" ripple>Bank Slips</v-tab>
      <v-tab key="iveri_failed" @click="fetchIverFailure()" class="earth-color" ripple>Iveri Failed Payments</v-tab>
      <v-tab key="mpesa" @click="fetchMpesaTransactions()" class="earth-color" ripple>Mpesa Transactions</v-tab>
      <v-tab key="all_payments" @click="fetchBookingPayments()" class="earth-color" ripple>All Payments</v-tab>
      <v-tab-item key="bank_slip">
        <v-container>
          <v-expansion-panel popout class="futuristic-expansion">
            <v-expansion-panel-content>
              <template slot="header">
                <h4 class="earth-color">GLOBAL SEARCH</h4>
              </template>
              <template slot="actions">
                <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
              </template>
              <find_booking_payment></find_booking_payment>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-container>
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h1 class="text-md-center earth-color">BANK SLIPS</h1>
            <div class="title-decoration"></div>
          </div>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              placeholder="Search bank slips..."
              single-line
              hide-details
              v-model="search"
              class="futuristic-input"
            ></v-text-field>
          </v-card-title>
          <v-flex lg12 md12 sm12 xs12>
            <v-data-table
              :headers="bank_slip_columns"
              :items="$bankSlipData"
              :search="search"
              :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
              class="futuristic-table"
            >
              <v-progress-linear
                slot="progress"
                color="#587e27"
                indeterminate
                height="3"
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ formated_date(props.item.created_at) }}</td>
                  <td class="font-weight-medium">{{ props.item.booking_ref_code }}</td>
                  <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
                  <td>{{ props.item.slip_reference }}</td>
                  <td>{{ props.item.currency_name }} {{ props.item.payment_amount }}</td>
                  <td>{{ props.item.receipt_details }}</td>
                  <td>{{ props.item.session_user }}</td>
                  <td class="has-text-right">
                    <v-btn
                      v-if="props.item.status == 1"
                      depressed
                      small
                      color="#587e27"
                      class="futuristic-btn action-btn"
                      @click.prevent="viewAllocationModal(props.item)"
                    >
                      Allocate
                    </v-btn>
                    <v-btn
                      v-else
                      depressed
                      small
                      color="#2196f3"
                      class="futuristic-btn action-btn"
                    >
                      Allocated
                    </v-btn>
                    <v-dialog
                      v-model="allocate_slip_modal"
                      persistent
                      max-width="1000px"
                    >
                      <v-card flat class="futuristic-card">
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex lg4 md4 sm12 xs12>
                              <v-container>
                                <v-text-field
                                  v-model="payment.mpesa_ref"
                                  label="Receipt Number"
                                  required
                                  :rules="requiredRules"
                                  type="text"
                                  class="futuristic-input"
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex lg4 md6 sm12 xs12>
                              <v-container class="action-buttons">
                                <v-btn
                                  depressed
                                  color="#587e27"
                                  class="futuristic-btn action-btn"
                                  @click="submitPayment()"
                                >
                                  Submit Payments
                                </v-btn>
                                <v-btn
                                  depressed
                                  color="#ef5350"
                                  class="futuristic-btn action-btn"
                                  @click="allocate_slip_modal = false"
                                >
                                  Close
                                </v-btn>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <td :colspan="bank_slip_columns.length">
                  <v-btn
                    depressed
                    color="#2196f3"
                    class="futuristic-btn action-btn"
                    :loading="this.$store.state.LoadingStore.loading"
                    @click="getMoreSlips()"
                  >
                    Get More Slips
                  </v-btn>
                  <vue-json-to-csv
                    :json-data="$bankSlipData"
                    csv-title="Bank Slips"
                    :labels="{
                      booking_ref_code: { title: 'Booking Ref' },
                      first_name: { title: 'First Name' },
                      last_name: { title: 'Last Name' },
                      slip_reference: { title: 'Slip Reference' },
                      currency_name: { title: 'Currency' },
                      payment_amount: { title: 'Amount' },
                      receipt_details: { title: 'Payment Receipt Details' },
                      session_user: { title: 'Created By' },
                      created_at: { title: 'Creation Date' },
                    }"
                  >
                    <v-btn
                      depressed
                      color="#587e27"
                      class="futuristic-btn action-btn"
                      :loading="$loadingTrue"
                    >
                      Download Bank Slips (CSV)
                    </v-btn>
                  </vue-json-to-csv>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card>
      </v-tab-item>
      <v-tab-item key="iveri_failed">
        <v-container>
          <v-expansion-panel popout class="futuristic-expansion">
            <v-expansion-panel-content>
              <template slot="header">
                <h4 class="earth-color">GLOBAL SEARCH</h4>
              </template>
              <template slot="actions">
                <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
              </template>
              <find_booking_payment></find_booking_payment>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-container>
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h1 class="text-md-center earth-color">IVERI FAILED PAYMENTS</h1>
            <div class="title-decoration"></div>
          </div>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              placeholder="Search iveri failures..."
              single-line
              hide-details
              v-model="search"
              class="futuristic-input"
            ></v-text-field>
          </v-card-title>
          <v-flex lg12 md12 sm12 xs12>
            <v-data-table
              :headers="iveri_failure_columns"
              :items="$bookingPaymentFailure"
              :search="search"
              :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
              class="futuristic-table"
            >
              <v-progress-linear
                slot="progress"
                color="#587e27"
                indeterminate
                height="3"
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="font-weight-medium">{{ props.item.booking_ref_code }}</td>
                  <td>{{ props.item.card_number }}</td>
                  <td>{{ props.item.reason }}</td>
                  <td>{{ formated_date(props.item.created_at) }}</td>
                </tr>
              </template>
              <template slot="footer">
                <td :colspan="iveri_failure_columns.length">
                  <v-btn
                    depressed
                    color="#2196f3"
                    class="futuristic-btn action-btn"
                    :loading="this.$store.state.LoadingStore.loading"
                    @click="getMoreIveriFails()"
                  >
                    Get More Iveri Fails
                  </v-btn>
                  <vue-json-to-csv
                    :json-data="$bookingPaymentFailure"
                    csv-title="Iveri Fails"
                    :labels="{
                      booking_ref_code: { title: 'Booking Ref' },
                      card_number: { title: 'Card Details' },
                      reason: { title: 'Reason' },
                      created_at: { title: 'Creation Date' },
                    }"
                  >
                    <v-btn
                      depressed
                      color="#587e27"
                      class="futuristic-btn action-btn"
                      :loading="$loadingTrue"
                    >
                      Download Iveri Fails (CSV)
                    </v-btn>
                  </vue-json-to-csv>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card>
      </v-tab-item>
      <v-tab-item key="mpesa">
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h1 class="text-md-center earth-color">MPESA TRANSACTIONS</h1>
            <div class="title-decoration"></div>
          </div>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              placeholder="Search mpesa transactions..."
              single-line
              hide-details
              v-model="search"
              class="futuristic-input"
            ></v-text-field>
          </v-card-title>
          <v-flex lg12 md12 sm12 xs12>
            <v-data-table
              :headers="columns"
              :items="mpesaTransactions"
              :search="search"
              :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
              class="futuristic-table"
            >
              <v-progress-linear
                slot="progress"
                color="#587e27"
                indeterminate
                height="3"
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ formated_date_time(props.item.updatedAt) }}</td>
                  <td>{{ props.item.payment_to }}</td>
                  <td class="font-weight-medium">{{ props.item.reference }}</td>
                  <td>{{ props.item.phone_number }}</td>
                  <td>{{ props.item.amount }}</td>
                  <td
                    :style="{
                      backgroundColor: props.item.payment === true ? '#44bd32' : props.item.payment === false ? '#ef5350' : 'transparent',
                      color: props.item.payment === true || props.item.payment === false ? 'white' : 'inherit'
                    }"
                  >
                    {{ props.item.payment === true ? 'Successful' : props.item.payment === false ? 'Not Successful' : 'Error Occurred' }}
                  </td>
                  <td>{{ props.item.merchant_request_id }}</td>
                  <td>{{ props.item.checkout_request_id }}</td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
                class="futuristic-alert"
              >
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-flex>
        </v-card>
      </v-tab-item>
      <v-tab-item key="all_payments">
        <v-container>
          <v-expansion-panel popout class="futuristic-expansion">
            <v-expansion-panel-content>
              <template slot="header">
                <h4 class="earth-color">GLOBAL SEARCH</h4>
              </template>
              <template slot="actions">
                <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
              </template>
              <find_booking_payment></find_booking_payment>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-container>
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h1 class="text-md-center earth-color">ALL BOOKING PAYMENTS</h1>
            <div class="title-decoration"></div>
          </div>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              placeholder="Search booking payments..."
              single-line
              hide-details
              v-model="search"
              class="futuristic-input"
            ></v-text-field>
          </v-card-title>
          <v-flex lg12 md12 sm12 xs12>
            <v-data-table
              :headers="all_booking_payments"
              :items="$bookingPayments"
              :search="search"
              :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
              class="futuristic-table"
            >
              <v-progress-linear
                slot="progress"
                color="#587e27"
                indeterminate
                height="3"
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="font-weight-medium">{{ props.item.booking_ref_code }}</td>
                  <td>{{ props.item.payment_method_name }}</td>
                  <td>{{ props.item.currency }} {{ props.item.amount_paid }}</td>
                  <td>{{ props.item.mpesa_reference }}</td>
                  <td>{{ props.item.card_first_four }}....{{ props.item.card_last_four }}</td>
                  <td>{{ props.item.session_user }}</td>
                  <td>{{ formated_date_time(props.item.created_at) }}</td>
                </tr>
              </template>
              <template slot="footer">
                <td :colspan="all_booking_payments.length">
                  <v-btn
                    depressed
                    color="#2196f3"
                    class="futuristic-btn action-btn"
                    :loading="this.$store.state.LoadingStore.loading"
                    @click="getMorePayments()"
                  >
                    Get More Payments
                  </v-btn>
                  <vue-json-to-csv
                    :json-data="$bookingPayments"
                    csv-title="Booking Payments"
                    :labels="{
                      booking_ref_code: { title: 'Booking Ref' },
                      payment_method_name: { title: 'Payment Method' },
                      currency: { title: 'Currrency' },
                      amount: { title: 'Amount' },
                      mpesa_reference: { title: 'Reference' },
                      card_first_four: { title: 'Card Details' },
                      session_user: { title: 'Created By' },
                      created_at: { title: 'Creation Date' },
                    }"
                  >
                    <v-btn
                      depressed
                      color="#587e27"
                      class="futuristic-btn action-btn"
                      :loading="$loadingTrue"
                    >
                      Download Booking Payments (CSV)
                    </v-btn>
                  </vue-json-to-csv>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
import SearchPaymentTabs from "./FindBookingPayments";
export default {
  name: "PaymentGateways",
  components: {
    VueJsonToCsv,
    find_booking_payment: SearchPaymentTabs,
  },
  data() {
    return {
      edit: false,
      requiredRules: [(v) => !!v || "This field is required"],
      search: "",
      page: 2,
      allocate_slip_modal: false,
      payment_gateway: {
        payment_gateway_id: "",
        method: "",
        name: "",
        code: "",
        currency: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      bank_slip_columns: [
        {
          text: "Created At",
          value: "created_at",
          class: 'table-header'
        },
        {
          text: "Booking Reference",
          value: "booking_ref_code",
          class: 'table-header'
        },
        {
          text: "Name",
          value: "first_name",
          class: 'table-header'
        },
        {
          text: "Bank Slip Reference",
          value: "slip_reference",
          class: 'table-header'
        },
        {
          text: "Amount",
          value: "payment_amount",
          class: 'table-header'
        },
        {
          text: "Payment Receipt",
          value: "receipt_details",
          class: 'table-header'
        },
        {
          text: "Added By",
          value: "session_user",
          class: 'table-header'
        },
        {
          text: "Action",
          value: "",
          class: 'table-header'
        },
      ],
      iveri_failure_columns: [
        {
          text: "Booking Reference",
          value: "booking_ref_code",
          class: 'table-header'
        },
        {
          text: "Card Number",
          value: "card_number",
          class: 'table-header'
        },
        {
          text: "Reason For Failure",
          value: "reason",
          class: 'table-header'
        },
        {
          text: "Created At",
          value: "created_at",
          class: 'table-header'
        },
      ],
      all_booking_payments: [
        {
          text: "Booking Reference",
          value: "booking_ref_code",
          class: 'table-header'
        },
        {
          text: "Payment Method",
          value: "payment_method_name",
          class: 'table-header'
        },
        {
          text: "Currency",
          value: "currency",
          class: 'table-header'
        },
        {
          text: "Transaction Reference",
          value: "mpesa_reference",
          class: 'table-header'
        },
        {
          text: "Card Details",
          value: "card_first_four",
          class: 'table-header'
        },
        {
          text: "Created By",
          value: "session_user",
          class: 'table-header'
        },
        {
          text: "Created At",
          value: "created_at",
          class: 'table-header'
        },
      ],
      payment: {
        booking_id: this.$route.params.booking_id,
        booking_amount: "",
        currency_id: "",
        payment_amount: "",
        mode: "",
        mpesa_ref: "",
        payment_gateway: "",
        phone: "254",
        last_four: "",
        first_four: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        booking_slip_public_id: "",
      },
      columns: [
        {
          text: "Updated At",
          value: "updatedAt",
          class: 'table-header'
        },
        {
          text: "Payment To",
          value: "payment_to",
          class: 'table-header'
        },
        {
          text: "OBTS Reference",
          value: "reference",
          class: 'table-header'
        },
        {
          text: "Phone Number",
          value: "phone_number",
          class: 'table-header'
        },
        {
          text: "Amount",
          value: "amount",
          class: 'table-header'
        },
        {
          text: "Transaction Status",
          value: "payment",
          class: 'table-header'
        },
        {
          text: "Merchant Request ID",
          value: "merchant_request_id",
          class: 'table-header'
        },
        {
          text: "Checkout Request ID",
          value: "checkout_request_id",
          class: 'table-header'
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("get_all_bank_slip_data");
    this.$store.commit("CURRENT_PAYMENTS_SEARCH", { tab_item: "bank_slip" });
  },
  methods: {
    submitPayment: function (data) {
      this.$store.dispatch("allocate_receipt", this.payment);
      this.allocate_slip_modal = false;
    },
    viewAllocationModal: function (slip_data) {
      this.payment.payment_method = "746bb582-89ed-4c83-ac3c-f25d9d60b266";
      this.payment.booking_id = slip_data.booking_public_id;
      this.payment.currency_id = slip_data.currency_id;
      this.payment.booking_amount = "";
      this.payment.payment_amount = slip_data.payment_amount;
      this.payment.mode = 0;
      this.payment.mpesa_ref = "";
      this.payment.phone = "254";
      this.payment.last_four = "";
      this.payment.first_four = "";
      this.payment.booking_slip_public_id = slip_data.booking_bank_slip_public_id;
      this.payment.session_id = localStorage.getItem("lkjhgfdsa");
      this.allocate_slip_modal = true;
    },
    fetchBankSlip: function () {
      this.$store.commit("CURRENT_PAYMENTS_SEARCH", { tab_item: "bank_slip" });
    },
    fetchMpesaTransactions: function () {
      let data = this.$store.state.PaymentMethodStore.mpesa_transactions;
      if (data.length == 0 || data == undefined) {
        this.$store.dispatch("fetch_mpesa_transactions");
      }
    },
    fetchIverFailure: function () {
      let data = this.$store.state.BookingStore.booking_payment_failure;
      if (data.length == 0 || data == undefined) {
        this.$store.dispatch("get_bookings_payment_failure");
      }
      this.$store.commit("CURRENT_PAYMENTS_SEARCH", { tab_item: "iveri_failed" });
    },
    fetchBookingPayments: function () {
      let data = this.$store.state.BookingStore.all_booking_payment;
      if (data.length == 0 || data == undefined) {
        this.$store.dispatch("get_bookings_payments");
      }
      this.$store.commit("CURRENT_PAYMENTS_SEARCH", { tab_item: "booking_payments" });
      this.$store.dispatch("get_all_payment_methods");
    },
    getMorePayments() {
      this.loading = true;
      if (this.page === 2) {
        this.$store.dispatch("get_more_bookings_payments", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_bookings_payments", this.page);
        this.page = this.page + 1;
      }
    },
    getMoreSlips() {
      this.loading = true;
      if (this.page === 2) {
        this.$store.dispatch("get_more_bank_slip_data", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_bank_slip_data", this.page);
        this.page = this.page + 1;
      }
    },
    getMoreIveriFails() {
      this.loading = true;
      if (this.page === 2) {
        this.$store.dispatch("get_more_bookings_payment_failure", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_bookings_payment_failure", this.page);
        this.page = this.page + 1;
      }
    },
  },
}
</script>

<style scoped>
/* Futuristic Container */
.payment-gateways-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-gateways-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.futuristic-expansion >>> .v-expansion-panel__header {
  background: #f5f7fa;
  border-radius: 8px;
}

.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  border-radius: 8px;
}

.futuristic-tabs >>> .v-tabs__item:hover {
  background-color: #f0f4f8;
  color: #587e27;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-gateways-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-btn {
    margin: 2px;
  }
}

@media (max-width: 600px) {
  .payment-gateways-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>